import React from 'react';
import PropTypes from 'prop-types';
import RouterNavigationPrompt from 'react-router-navigation-prompt';

import ConfirmNavigation from './modals/ConfirmNavigation';

class NavigateAwayPrompt extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = { isMounted: false };
  }

  componentDidMount() {
    // eslint-disable-next-line react/no-did-mount-set-state
    this.setState({ isMounted: true });
  }

  componentWillUnmount() {
    this.setState({ isMounted: false });
  }

  render() {
    const { when, message } = this.props;
    const { isMounted } = this.state;
    // Don't render the component until mount to avoid dual binding to the history object.
    // https://github.com/ReactTraining/react-router/issues/5707.
    if (isMounted) {
      return (
        <RouterNavigationPrompt when={when} renderIfNotActive={false}>
          {({ isActive, onConfirm, onCancel }) => (
            <ConfirmNavigation
              message={message}
              isOpen={isActive}
              onConfirm={onConfirm}
              onCancel={onCancel}
            />
          )}
        </RouterNavigationPrompt>
      );
    }
    return null;
  }
}

NavigateAwayPrompt.displayName = 'NavigateAwayPrompt';

NavigateAwayPrompt.propTypes = {
  when: PropTypes.bool.isRequired,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
};

export default NavigateAwayPrompt;



// WEBPACK FOOTER //
// ./src/components/NavigateAwayPrompt.js